import { render, staticRenderFns } from "./AppDataTableTopActions.vue?vue&type=template&id=2b2db7e5&scoped=true&"
import script from "./AppDataTableTopActions.vue?vue&type=script&lang=js&"
export * from "./AppDataTableTopActions.vue?vue&type=script&lang=js&"
import style0 from "./AppDataTableTopActions.vue?vue&type=style&index=0&id=2b2db7e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2db7e5",
  null
  
)

export default component.exports